'use client';

import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useDialogs } from '@/components/dialogs/hooks';
import { Modals } from '@/helpers/modals';
import { useNDBFlow } from '@/hooks/useNDBFlow';
import { useCommonStore, useModalsStore } from '@/store';

export const useNDBConfirmEmailModals = () => {
  const { localNDBFlow, isNDBFlow, isAfterReleaseDate } = useNDBFlow();
  const hasUserUsedFreespins = useCommonStore.use.hasUserUsedFreespins();
  const open = useModalsStore.use.open();
  const { modal } = useDialogs();
  const { isAuthenticated, pendingUser, user } = useCommonStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      pendingUser: state.pendingUser,
      user: state.user,
    }))
  );

  useEffect(() => {
    if (
      !isAuthenticated ||
      !user ||
      pendingUser ||
      modal ||
      !isNDBFlow ||
      hasUserUsedFreespins !== false
    )
      return;

    if (!localNDBFlow?.isNDBEmailVerifiedShown && isAfterReleaseDate) {
      open(Modals.NDBEmailVerified);
    }

    if (!localNDBFlow?.isNDBEmailConfirmShown && !user.confirmedAt) {
      open(Modals.NDBEmailConfirm);
    }
  }, [
    isAuthenticated,
    pendingUser,
    user,
    hasUserUsedFreespins,
    modal,
    open,
    isAfterReleaseDate,
  ]);
};
